export const SEGMENTATION = {
  ALL: "All",
  DESCRIPTION:
    'Take more control of how much Personal Health Information (PHI) this team member can see, by selecting a segment based on your Office Location values sent on your eligibility files. If you do not want to restrict access for this team member, select "All."',
  LABEL: "Which part of your population can your team member access?",
  LANDING_PAGE_TEXT:
    "You have restricted access to Compass features and can only see individual members. Please search for an employee to see their details page."
};
